<template>
  <div>
    <!-- 更多区域 -->
    <transition name="van-slide-right">
      <div class="more">
        <!-- 返回栏 -->
        <div class="more_back_bar">
          <van-nav-bar title="更多" left-arrow @click-left="moreBack" placeholde />
        </div>
        <div style="height:46px"></div>
        <div class="more_content">
          <div class="more_content_box">
            <div class="more_title">车型</div>
            <div class="params_box">
              <div class="vehicle_type_box_item" v-for="item in vehicleTypeList" :key="item.id" :class="{ active: item.value == vehicleType }" @click="chooseParams('vehicleType', item.value)">
                <img :src="item.iconCls" class="vehicle_type_img" />
                <span>{{ item.text }}</span>
              </div>
            </div>
          </div>
          <div class="more_content_box">
            <div class="more_title">专区</div>
            <div class="params_box">
              <div class="vehicle_type_box_item" v-for="item in certifyTagList" :key="item.id" :class="{ active: item.value == certifyTag }" @click="chooseParams('certifyTag', item.value)">
                <span>{{ item.text }}</span>
              </div>
            </div>
          </div>
          <div class="more_content_box">
            <div class="more_title">里程</div>
            <div class="params_box">
              <div class="vehicle_type_box_item" v-for="item in mileageList" :key="item.id" :class="{ active: item.value == mileage }" @click="chooseParams('mileage', item.value)">
                <span>{{ item.text }}</span>
              </div>
            </div>
          </div>
          <div style="height:0.5rem"></div>
        </div>
        <div class="bottom_btn">
          <div @click="moreReset">重置</div>
          <div @click="submit">确认</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      vehicleType: 0,
      mileage: 0,
      certifyTag: 0,

      vehicleTypeList: [],
      certifyTagList: [],
      mileageList: []
    }
  },
  created() {
    var query = this.$route.query
    if (query.vehicleType) {
      this.vehicleType = query.vehicleType
    }
    if (query.mileage) {
      this.mileage = query.mileage
    }
    if (query.certifyTag) {
      this.certifyTag = query.certifyTag
    }
    this.loadData()
  },
  methods: {
    // 获取筛选条件相关
    async loadData() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/config/commonBox', {
        params: {
          selectCode: 'carMileage,specialArea,hotModel',
          isshow: 'carMileage,specialArea,hotModel'
        }
      })
      if (data.success) {
        this.mileageList = data.data.carMileage
        this.certifyTagList = data.data.specialArea
        this.vehicleTypeList = data.data.hotModel
      }
    },
    // 关闭更多
    moreBack() {
      this.$router.back()
    },
    // 选择参数
    chooseParams(name, value) {
      this[name] = value
    },
    // 重置
    moreReset() {
      this.vehicleType = 0
      this.mileage = 0
      this.certifyTag = 0
    },
    // 确认
    submit() {
      this.$router.push({
        path: '/buy-car',
        query: {
          vehicleType: this.vehicleType,
          mileage: this.mileage,
          certifyTag: this.certifyTag
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.more_back_bar {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 999;
}
.more_content {
  padding: 0 16px;
  .more_content_box {
    .more_title {
      height: 36px;
      line-height: 30px;
    }
    .params_box {
      display: flex;
      flex-wrap: wrap;
      .vehicle_type_box_item {
        display: flex;
        flex: 0 0 31%;
        flex-direction: column;
        color: #757a7e;
        align-items: center;
        justify-content: center;
        background-color: #f2f2f2;
        box-sizing: border-box;
        margin-bottom: 10px;
        margin-right: 10px;
        padding: 10px 0 8px;
        .vehicle_type_img {
          margin-bottom: 5px;
          width: 0.7rem;
          height: 0.3rem;
        }
      }
      & :nth-child(3n) {
        margin-right: 0;
      }
    }
  }
}
.more_back_bar {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 999;
}
.more_content {
  padding: 0 16px;
  .more_content_box {
    .more_title {
      height: 36px;
      line-height: 30px;
    }
    .params_box {
      display: flex;
      flex-wrap: wrap;
      .vehicle_type_box_item {
        display: flex;
        flex: 0 0 31%;
        flex-direction: column;
        color: #757a7e;
        align-items: center;
        justify-content: center;
        background-color: #f2f2f2;
        box-sizing: border-box;
        margin-bottom: 10px;
        margin-right: 10px;
        padding: 10px 0 8px;
        .vehicle_type_img {
          margin-bottom: 5px;
          width: 0.7rem;
          height: 0.3rem;
        }
      }
      & :nth-child(3n) {
        margin-right: 0;
      }
    }
  }
}
.active {
  color: #4ca8ff !important;
  background-color: #e3ecfd !important;
}

.bottom_btn {
  position: fixed;
  bottom: 0;
  width: 3.75rem;
  height: 0.5rem;
  display: flex;
  line-height: 0.5rem;
  box-sizing: content-box;

  & div:nth-child(1) {
    width: 30%;
    text-align: center;
    border-top: 1px solid #f2f2f2;
    background-color: #fff;
  }
  & div:nth-child(2) {
    width: 70%;
    text-align: center;
    color: #fff;
    background-color: #1989fa;
  }
}
</style>
